@if (!!formViewData.formSpec && ((legacyWebUI && url3_5) || (uiCompare && url3_5))) {
  @if (unsupportedPattern && !isProduction) {
    <p style="font-weight: bold; color:red; height: 20px;text-align: center; position:absolute; width:100%">
      CURRENTLY UNSUPPORTED SOHO XI PATTERN DETECTED
    </p>
  }
  <lm-html-url-doc
    [url]="url3_5"
    [showLoading]="false"
    (titleChanged)="onTitleChanged($event)"
    ></lm-html-url-doc>
}

@if (isInOverlay && formSpec && !isSearchForm && !formSpec.dependentForm) {
  <div [class.header-border]="true"
       [class.overlay-toolbar]="true">
    <lm-toolbar
      [toolbarIdPrefix]="formSpec.busFormSpec.name"
      [automationId]="formSpec.automationId"
      [inHeader]="false"
      [isInOverlay]="true"
      [showOverlayBackButton]="showOverlayBackButton"
      [allowOverlayInteractions]="false"
      [sectionTitle]="formTitle"
      [buttons]="overlayButtons | async"
      [showCalledOutMenuButton]="showCalledOutMenuButton"

      (sendContextMessageEvent)="onSendContextMessageEvent($event)"
      (toolbarButtonEvent)="onToolbarButtonEvent($event)"
      (updateToolbarStateEvent)="onUpdateToolbarStateEvent($event)">
      ></lm-toolbar>
  </div>
}

@if (bannerInRoute && isRouterOutletRootComponent) {
  <soho-header #SohoHeader [hasTabs]="false" [hasToolbar]="false">
    <ng-container *ngTemplateOutlet="ToolbarMarkup"></ng-container>
  </soho-header>
} @else {
  <ng-container *ngTemplateOutlet="ToolbarMarkup"></ng-container>
}

@if (routeReuseMode && isRouterOutletRootComponent && lmContextService.isDeveloper()) {
  <div class="font-size-px-16 route-reuse-indicator"
      soho-tooltip [content]="'Screen Display Time / First Load Template Time - Loadtime Times Improved<br> <br> Green = Template in use.<br>  Blue = Template not available and will be saved'"
    [class.route-reuse-indicator-active]="hasStoredRoute()">Route Reuse {{hasStoredRoute() ? 'Active': ''}} - {{displayLoadTime()}} / {{getRouteReuseTemplateLoadTime()}} - {{getSpeedIncrease()}} x+</div>
}
@if (!legacyWebUI || uiCompare) {
<div soho-busyindicator
    [ngClass]="{'scrollable' : isMingleInbox || isMingleOverlay || hideTitleManageScroll || isInOverlay }"
    [style.height]="isInOverlay && !isSearchForm && !formSpec?.dependentForm ? 'calc(100vh - 170px)' : !isMingleOverlay  ? '100%' : 'calc(100% - 50px)'"
    [text]="' '"
    [displayDelay]="0"
    [blockUI]="true"
    [transparentOverlay]="false"
    [timeToComplete]="this.uiLoadingIndicatorTimeout"
    [class.isMingleWidget]="isMingleWidget"
    [class.hide-title-or-mingle-inbox]="(isMingleInbox || isMingleOverlay || hideTitleManageScroll) && !isPageContextForm"
    [class.page-context-form]="!(isMingleInbox || isMingleOverlay || hideTitleManageScroll) && isPageContextForm"
>
  @if (emptyMessage !== null) {
    <div soho-emptymessage [emptyMessageOptions]="emptyMessage"></div>
  }

  @if (formViewData.formSpec && formViewData.dataView && emptyMessage === null) {
    <div id='{{formSpec?.busFormSpec?.name}}' class="lmc" [class.lm-form-content-wrapper]="isCompositeForm || isActionFormWithSections">
      @if (formViewData.dataView) {
        @if (!hideLayout) {
          <lm-form-content #LMFormContentComponent
              [formUrlInfo]="formUrlInfo"
              [formSpec]="formViewData.formSpec"
              [formOptions]="formOptions"
              [specFields]="specFields"
              [layout]="layout"
              [model]="model"
              [placeHolder]="placeHolder"
              [formState]="formState"
              [formPersonalization]="formPersonalization"
              [fromDataView]="fromDataView"
              [parentIsModal]="parentIsModal"
              [instanceId]="instanceId"
              [inFormOverlay]="isInOverlay"
              (searchButtonClicked)="onSearchClicked($event)"
              (customizeButtonClicked)="onCustomizeClicked($event)"
              [listUrlInfo]="listUrlInfo"
              (clearSearchButtonClicked)="onClearSearchClicked($event)"
              (fieldEvent)="onFieldEvent($event)"
              (stepPanelEvent)="onStepPanelEvent($event)"
              (contentModified)="onContentModified($event)"
              (updateToolbarStateEvent)="onUpdateToolbarStateEvent($event)"
              (sendContextMessageEvent)="onSendContextMessageEvent($event)"
              (sendShortcutMessage)="onSendShortcutMessage($event)"
              (specialActionsToolbarButtonEvent)="onSpecialActionToolbarButtonEvent($event)"
              (panelTransactionEvent)="onPanelTransactionEvent($event)"
              (drillAroundEvent)="onDrillAroundEvent($event)"
              (matrixActionEvent)="onRunMatrixActionEvent($event)"
              (contentLoadEvent)="onContentLoadEvent($event)"
              (startComponentTrackEvent)="onStartComponentTrackEvent($event)"
              (contentRendered)="onContentRendered()"
          ></lm-form-content>
        }
      }
    </div>
  }
</div>
}
@if (isMingleOverlay && !isResponseRequired && !parentIsModal && !isStepProcessForm && !isSearchForm) {
<div class="modal-buttonset" style="position:relative; width:100%;">
  <button id="PortalOverlay_Cancel"
    class="btn-modal no-ripple hide-focus"
    data-automation-id="lm-UpdateActionForm-modal-cancel"
    [style.width]="portalOverlayButtonWidth"
    (click)="onPortalOverlayClickCancel()">
    <span>{{'Cancel' | translate}}</span>
  </button>
  @if (portalSaveAsDraftButton) {
    <button id="PortalOverlay_SaveAsDraft"
      class="btn-modal no-ripple hide-focus"
      data-automation-id="lm-PortalOverlay-modal-cancel"
      [style.width]="portalOverlayButtonWidth"
      (click)="onPortalOverlayClickEvent(portalSaveAsDraftButton)">
      <span>{{'SaveAsDraft' | translate}}</span>
    </button>
  }
  @if (portalScheduleButton) {
    <button id="PortalOverlay_Schedule"
        class="btn-modal no-ripple hide-focus"
        data-automation-id="lm-PortalOverlay-modal-schedule"
        [style.width]="portalOverlayButtonWidth"
        (click)="onPortalOverlayClickEvent(portalScheduleButton)">
        <span>{{'Schedule' | translate}}</span>
    </button>
  }
  <button
    id="PortalOverlay_Submit"
    class="btn-modal btn-modal-primary no-validation no-ripple hide-focus"
    data-automation-id="lm-PortalOverlay-modal-primary"
    [style.width]="portalOverlayButtonWidth"
    (click)="onPortalOverlayClickEvent(portalSubmitButton)">
    <span>{{portalSubmitButton?.actionReference?.label}}</span>
  </button>
</div>
}

<div #dialogPlaceholder id="lmFormDialogPlaceholder" class="lmDialogPlaceholder"></div>

<ng-template #ToolbarMarkup>
  <!--  <ng-container *ngIf="hideTitleBar">   -->
    <div [class.header-border]="mingleInboxToolbar">
        @if (mingleInboxMultiToolbar) {
            <lm-toolbar
                [style.display]="mingleInboxMTHTML ? 'block' : 'none'"
                [inHeader]="false"
                [toolbarIdPrefix]="this.formSpec.busFormSpec.name + '_title'"
                [automationId]="this.formSpec.automationId + '-title'"
                [sectionTitle]="formTitle"
                [style.height]="mingleInboxMTHTML ? '42px' : ''"
                [style.align-content]="'center'"
                [class.hideTitleToolbar]="true"
                [class.banner-in-route]="true"
                (sendContextMessageEvent)="onSendContextMessageEvent($event)"
                (updateToolbarStateEvent)="onUpdateToolbarStateEvent($event)"
            ></lm-toolbar>
            <lm-toolbar
                #MingleFormToolbar
                [class.mingle-inbox-hide-title]="mingleInboxMTHTML"
                [inHeader]="isRouterOutletRootComponent && bannerInRoute"
                [toolbarIdPrefix]="this.formSpec.busFormSpec.name"
                [automationId]="this.formSpec.automationId"
                [sectionTitle]="showSectionTitleOnForm ? formTitle : ''"
                [buttons]="toolbarButtons | async"
                [moreMenuSettings]="toolbarMoreMenuSettings"
                [class.hideTitleToolbar]="true"
                [class.implements-cart-view]="formSpec.busFormSpec.implementsCartView"
                [class.banner-in-route]="true"

                (appMenuTriggerEvent)="onAppMenuTriggerEvent($event)"

                (sendContextMessageEvent)="onSendContextMessageEvent($event)"
                (toolbarButtonEvent)="onToolbarButtonEvent($event)"
                (updateToolbarStateEvent)="onUpdateToolbarStateEvent($event)"
            ></lm-toolbar>
        } @else {
            @if (formSpec && showToolbarOnForm && !isMingleOverlay && (!legacyWebUI || uiCompare)) {
              <lm-toolbar
                  #FormToolbar
                  [inHeader]="isRouterOutletRootComponent && bannerInRoute"
                  [toolbarIdPrefix]="this.formSpec.busFormSpec.name"
                  [automationId]="this.formSpec.automationId"
                  [sectionTitle]="showSectionTitleOnForm ? formTitle : ''"
                  [buttons]="toolbarButtons | async"
                  [moreMenuSettings]="toolbarMoreMenuSettings"
                  [isInOverlay]="isInOverlay"
                  [showOverlayBackButton]="false"
                  [hideOverflowMenuButton]="isInOverlay"
                  [allowOverlayInteractions]="false"
                  [class.hideTitleToolbar]="true"
                  [class.implements-cart-view]="formSpec.busFormSpec.implementsCartView"
                  [class.banner-in-route]="true"
                  [class.header-border]="isInOverlay"
                  (appMenuTriggerEvent)="onAppMenuTriggerEvent($event)"

                  (sendContextMessageEvent)="onSendContextMessageEvent($event)"
                  (toolbarButtonEvent)="onToolbarButtonEvent($event)"
                  (updateToolbarStateEvent)="onUpdateToolbarStateEvent($event)"
                ></lm-toolbar>
            }
        }
    </div>
  <!--  </ng-container>  -->
</ng-template>
